import { defineComponent, inferProps, type Component, type ReactiveComponent } from "vue-utils"
import type { GenericDisplayProps } from "./DisplayComponent"

type Props<T> = GenericDisplayProps<T[]>

export function createArrayDisplay<T>(DisplayComponent: Component<GenericDisplayProps<T>>) {
	const ArrayDisplay: ReactiveComponent<Props<T>> = (props) => {
		return () => (
			<ul class="mb-0" style="padding-left: 1.5rem">
				{(props.value ?? []).map((value, index) => (
					<li key={index}>
						<DisplayComponent value={value} />
					</li>
				))}
			</ul>
		)
	}

	return defineComponent(ArrayDisplay, inferProps<Props<T>>())
}
